import styled from 'styled-components'

import Icon from '../Icon'

const Logo = styled(Icon).attrs({
  icon: 'HeaderLogo',
})`
  margin: 8px 0;
  height: 48px;
  width: 178px;
`

export default Logo
